module.exports = __webpack_public_path__ + "static/penthouse-32dfc5f566124d35e2d0639c36f39348.webp";